import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";
import { useContent, t, parseHiddenSet } from "@/hooks/useContent";
import Seo from "@/components/Seo";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const c = useContent();
  const hidden = parseHiddenSet(c);
  const H = (id) => hidden.has(id);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  if (H("testimonials.section")) return null;
  const visible = items.filter((it) => !H(`testimonial:${it.id}`));
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <Seo
        path="/testimonials"
        title="Reviews — What Bharat Says About B-Raw Snacks"
        description="Real customer reviews of B-Raw's hand-crafted, FSSAI-certified snacks. See why Bharat loves our 5 signature flavours at ₹10 a pack."
      />
      <div className="max-w-3xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D9381E]">
          Real Reviews
        </div>
        {!H("testimonials.title") && (
          <h1 className="mt-2 font-display font-black text-5xl sm:text-6xl tracking-tighter text-[#111]">
            {t(c, "testimonials.title", "What Bharat says about their B-Raw pack.")}
          </h1>
        )}
      </div>

      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="testimonials-grid">
        {visible.map((t, i) => (
          <div
            key={t.id}
            data-testid={`testimonial-${t.id}`}
            className="relative p-6 rounded-3xl bg-white border border-black/10 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(0,0,0,0.08)] transition-all"
            style={{
              backgroundColor: i % 3 === 0 ? "#FFEDD5" : i % 3 === 1 ? "#DBEAFE" : "#DCFCE7",
            }}
          >
            <Quote className="text-[#D9381E]" size={28} />
            <div className="mt-3 flex">
              {Array.from({ length: 5 }).map((_, idx) => (
                <Star
                  key={idx}
                  size={16}
                  className={idx < t.rating ? "fill-[#F2A900] text-[#F2A900]" : "text-black/20"}
                />
              ))}
            </div>
            <p className="mt-4 text-[#111] leading-relaxed">{t.text}</p>
            <div className="mt-6 flex items-center justify-between">
              <div>
                <div className="font-display font-bold text-[#111]">{t.name}</div>
                <div className="text-xs text-[#4B5563]">{t.location}</div>
              </div>
              <div className="text-xs font-bold uppercase tracking-widest text-[#111]/60">
                {t.product}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
